import React, { useState, useEffect } from "react";
import Data from "../App";
import { map, distinctUntilChanged } from "rxjs/operators";
import { List, Map, is, fromJS } from "immutable";

const UiBindingEditView = ({ binding, onChange }) => {
  function addCase() {
    console.log("addCase " + binding.get("cases").size);
    let newDummyCase = fromJS({ case: "case", case_value: "value" });
    if (binding.get("cases")) {
      onChange(binding.updateIn(["cases"], list => list.push(newDummyCase)));
    } else {
      onChange(binding.set("cases", new List(newDummyCase)));
    }
  }
  return (
    <div>
      <div className="BindingRow">
        <div className="BindingAttribute">
          <input
            type="text"
            value={binding.get("attribute")}
            onChange={e => onChange(binding.set("attribute", e.target.value))}
          />
        </div>
        <div className="BindingCases">
          {binding.get("cases").map((aCase, index) => (
            <div key={index} className="BindingCaseRow">
              <div className="BindingCase">
                <input
                  type="text"
                  value={aCase.get("case")}
                  onChange={e =>
                    onChange(
                      binding.setIn(["cases", index, "case"], e.target.value)
                    )
                  }
                />
              </div>
              <div className="BindingCase">
                <input
                  type="text"
                  value={aCase.get("case_value")}
                  onChange={e =>
                    onChange(
                      binding.setIn(
                        ["cases", index, "case_value"],
                        e.target.value
                      )
                    )
                  }
                />
              </div>
              <div
                onClick={e => {
                  e.stopPropagation;
                  onChange(binding.deleteIn(["cases", index]));
                }}
              >
                X
              </div>
            </div>
          ))}
        </div>
      </div>
      <span
        onClick={e => {
          e.stopPropagation();
          addCase();
        }}
      >
        +case
      </span>
    </div>
  );
};
export default UiBindingEditView;



// WEBPACK FOOTER //
// ./src/components/UiBindingEditView.js